import { Box, Typography } from '@mui/material';

import { CommentComposer } from './CommentComposer';
import { CommentList } from './CommentList';
import { SectionTitle } from './styles';
import {
  useCompanyComments,
  useCompanyCommentsHistory,
} from './useCompanyComments';

interface CommentsSectionProps {
  noticeId: number;
  licensedCompanyId: number | undefined;
}

/**
 * Comentários na tela de análise. Fica fora das abas de propósito: a observação
 * é sobre a empresa, não sobre um eixo de análise.
 */
export function CommentsSection({
  noticeId,
  licensedCompanyId,
}: CommentsSectionProps): JSX.Element {
  const { comments, loading, submitting, submitComment } = useCompanyComments({
    noticeId,
    licensedCompanyId,
    enabled: true,
  });
  const { history, loading: historyLoading } = useCompanyCommentsHistory(
    licensedCompanyId,
    noticeId,
    true
  );

  return (
    <Box my={5}>
      <Typography color="common.grey" fontSize={21} fontWeight={600} my={3}>
        Comentários dos operadores
      </Typography>

      <SectionTitle>Neste edital</SectionTitle>
      <CommentList
        comments={comments}
        loading={loading}
        emptyText="Nenhum comentário neste edital."
      />
      <CommentComposer submitting={submitting} onSubmit={submitComment} />

      <SectionTitle>Histórico de outros editais</SectionTitle>
      <CommentList
        comments={history}
        loading={historyLoading}
        emptyText="Nenhum comentário em editais anteriores."
        showNotice
      />
    </Box>
  );
}
